<app-header-nav>
  Statistik
</app-header-nav>

<ion-content class="ion-padding">
  <div class="container">

    <ion-row>
      <ion-col size="12"
               size-md="6">
        <h2 class="mb-20 ion-text-center">Dein Schreibvolumen</h2>
        <app-journal-day-activity-calendar (dayClicked)="showDayInBlog($event)">
        </app-journal-day-activity-calendar>
      </ion-col>
      <ion-col size="12"
               size-md="6">

        <div *ngIf="currentStreak$ | async as currentStreak"
             class="streak-card">
          <h3>Aktueller Streak</h3>
          <div class="streak-card-days-container">
            <div>{{ currentStreak.daysCount }}</div>
            <div>Tag{{ currentStreak.daysCount > 1 ? 'e' : '' }}</div>
          </div>
          <div>Seit dem {{ currentStreak.startAt | date: 'd. MMM YYYY' }}</div>
        </div>

        <div *ngIf="highestStreak$ | async as highestStreak"
             class="streak-card">
          <h3>Längster Streak</h3>

          <div class="streak-card-days-container">
            <div>{{ highestStreak.days_count }}</div>
            <div>Tag{{ highestStreak.days_count > 1 ? 'e' : '' }}</div>
          </div>


          <div>{{ highestStreak.start_at | date: 'd. MMM YYYY' }}- {{ highestStreak.end_at | date: 'd. MMM YYYY' }}
          </div>
        </div>

      </ion-col>
    </ion-row>

  </div>

</ion-content>

